import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import type { RootState } from '../store';

import { eventsService } from './_deps';

export const unreserveFromEvent = createAsyncThunk<
  void,
  { eventId: string; telegramIds: number[] },
  { state: RootState }
>('events/unreserveSlot', async (params, thunkApi) => {
  const { dispatch } = thunkApi;
  const updatedEvent = await eventsService.unreserveFromEvent({
    eventId: params.eventId,
    telegramIds: params.telegramIds,
  });
  dispatch(entitiesActions.upsertEvent(updatedEvent));
});
